// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611041136/js/" + chunkId + "." + {"44":"efd154f7","225":"09b26e2d","481":"b59fdba2","486":"164c68c4","770":"a22c42d5"}[chunkId] + ".0.24925255475570385.chunk.js";
};